import authService from './auth.service';
import inventoryService from './inventory.service';
import petService from './pet.service';
import customerService from './customer.service';

/**
 * Unified API service - re-exports all domain services.
 * Provides backward compatibility while keeping services organized.
 * 
 * @deprecated Import specific services directly (auth.service, pet.service, etc.)
 */
class ApiService {
  // Auth methods
  login = authService.login.bind(authService);
  logout = authService.logout.bind(authService);
  getCurrentUser = authService.getCurrentUser.bind(authService);
  isAuthenticated = authService.isAuthenticated.bind(authService);
  getUserData = authService.getUserData.bind(authService);
  storeAuthData = authService.storeAuthData.bind(authService);

  // Inventory methods
  getInventory = inventoryService.getInventory.bind(inventoryService);
  getCategories = inventoryService.getCategories.bind(inventoryService);
  getCategoryByCode = inventoryService.getCategoryByCode.bind(inventoryService);

  // Pet methods
  getPets = petService.getPets.bind(petService);
  getPetDetails = petService.getPetDetails.bind(petService);
  createPet = petService.createPet.bind(petService);
  updatePet = petService.updatePet.bind(petService);
  deletePet = petService.deletePet.bind(petService);

  // Customer methods
  getCustomers = customerService.getCustomers.bind(customerService);
  createCustomer = customerService.createCustomer.bind(customerService);
  updateCustomer = customerService.updateCustomer.bind(customerService);
  deleteCustomer = customerService.deleteCustomer.bind(customerService);
}

// Export singleton instance for backward compatibility
export default new ApiService();

// Also export individual services for direct import
export { authService, inventoryService, petService, customerService };
